export default __webpack_public_path__ + "static/sobre-14fbcc11bdaa7c4e4608a6bca78afcf8.jpg";